import { render, staticRenderFns } from "./claimTable.vue?vue&type=template&id=61ce4c3e&scoped=true"
import script from "./claimTable.vue?vue&type=script&lang=js"
export * from "./claimTable.vue?vue&type=script&lang=js"
import style0 from "./claimTable.vue?vue&type=style&index=0&id=61ce4c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce4c3e",
  null
  
)

export default component.exports